<mat-tab-group mat-align-tabs="center" style="margin-top: 0 !important;">
    <mat-tab *ngIf="!disableEditFormTab" label="Gruppe bearbeiten">
        <mat-card appearance="outlined">
            <mat-card-content style="height: 450px;" [formGroup]="editFormData">
                <div class="columns is-6">
                    <div class="column is-6 margin-bot-0">
                        <label for="edit-group-name">Gruppenname</label>
                    </div>
                    <div class="column is-6 margin-bot-0">
                        <label>Rollen</label>
                    </div>
                </div>
                <div class="columns is-6">
                    <div class="column is-6">
                        <input class="custom-input" formControlName="name" type="text" id="edit-group-name" placeholder="Gruppenname" value="{{this.data.groups[this.data.active].name}}">
                    </div>
                    <div class="column is-6">
                        <div class="columns">
                            <div class="column is-10">
                                <label>
                                    Admin
                                </label>
                            </div>
                            <div class="column is-2">
                                <mat-slide-toggle formControlName="role_admin" color="primary"></mat-slide-toggle>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-10">
                                <label>
                                    User
                                </label>
                            </div>
                            <div class="column is-2">
                                <mat-slide-toggle formControlName="role_user" color="primary"></mat-slide-toggle>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-6">
                    <div class="column is-6">
                        <div class="columns">
                            <div class="column is-10">
                                <label>Neue Bestellungen Einsehen</label>
                            </div>
                            <div class="column is-2">
                                <mat-slide-toggle formControlName="can_view" color="primary"></mat-slide-toggle>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-10">
                                <label>Neue Bestellungen Downloaden</label>
                            </div>
                            <div class="column is-2">
                                <mat-slide-toggle formControlName="can_download" color="primary"></mat-slide-toggle>
                            </div>
                        </div>
                    </div>
                    <div class="column is-6">
                        <div class="columns">
                            <div class="column is-10">
                                <label>
                                    Behördenauskunft - Bestellung freigeben
                                </label>
                            </div>
                            <div class="column is-2">
                                <mat-slide-toggle formControlName="can_order" color="primary"></mat-slide-toggle>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns">
                    <div class="column is-fullwidth" style="height: 150px;">
                        <app-invites-list [invites]="invites!"></app-invites-list>
                    </div>
                </div>
            </mat-card-content>
            <mat-card-actions align="end">
                <a class="button cancel" (click)="cancel()" style="vertical-align: middle; margin-right:1em">Abbrechen</a>
                <a class="button" (click)="editGroup()" style="vertical-align: middle">Speichern</a>
                <a class="button cancel last" [matTooltip]="getTooltip()" matTooltipPosition="above"
                   (mousedown)="startTimer()"
                   (mouseup)="cancelTimer()"
                   (mouseleave)="cancelTimer()"
                    style="vertical-align: middle">
                    <mat-progress-spinner class="spinner" *ngIf="deleteInProgress" mode="determinate"
                                          [diameter]="25" [value]="progressValue" [strokeWidth]="3">
                    </mat-progress-spinner>
                    Löschen
                </a>
            </mat-card-actions>
        </mat-card>
    </mat-tab>
    <mat-tab *ngIf="!disableCreateFormTab" label="Gruppe anlegen">
        <mat-card appearance="outlined">
            <mat-card-content style="height: 450px;" [formGroup]="newFormData">
                <div class="columns is-6">
                    <div class="column is-6 margin-bot-0">
                        <label for="group-name">Gruppenname</label>
                    </div>
                    <div class="column is-6 margin-bot-0">
                        <label for="permission-copy">Berechtigungen kopieren von</label>
                    </div>
                </div>
                <div class="columns is-6">
                    <div class="column is-6">
                        <input id="group-name" formControlName="name" class="custom-input" type="text" placeholder="Gruppenname">
                    </div>
                    <div class="column is-6">
                        <div class="select" style="width: 100% !important;">
                            <select id="permission-copy" formControlName="permissions" (change)="copyUserGroupData()" class="custom-input">
                                <option value="-1" selected>Vorhandene Gruppe auswählen</option>
                                <option *ngFor="let group of this.data.groups; let i = index" value="{{i}}">{{group.name}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="columns is-6">
                    <div class="column is-6">
                        <div class="tablefix">
                            <label>E-Mail-Adressen</label>
                            <mat-form-field id="mail-chip-field" class="example-chip-list" appearance="fill">
                                <mat-label>E-Mail-Adressen</mat-label>
                                <mat-chip-grid #chipList id="mail-chip-list" aria-label="E-Mail-Adressen">
                                    <mat-chip-row *ngFor="let mail of emails" (removed)="remove(mail)">
                                        {{mail}}
                                        <div>
                                            <mat-icon matChipRemove>cancel</mat-icon>
                                        </div>
                                    </mat-chip-row>
                                </mat-chip-grid>
                                <input style="margin-top: 1em !important; width: 100%;" type="email" placeholder="Neue E-Mail Adresse"
                                       [matChipInputFor]="chipList"
                                       [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                       [matChipInputAddOnBlur]="addOnBlur"
                                       (matChipInputTokenEnd)="add($event)">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="column is-6">
                        <div class="columns">
                            <div class="column is-10">
                                <label for="new_role_admin">
                                    Admin-Rolle
                                </label>
                            </div>
                            <div class="column is-2">
                                <mat-slide-toggle  formControlName="role_admin" color="primary" id="new_role_admin"></mat-slide-toggle>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-10">
                                <label for="info">
                                    Behördenauskunft - Bestellung freigeben
                                    <mat-icon class="small-icon"
                                              *ngIf="newFormData.controls['can_order'].value === true && newFormData.controls['can_view'].value === false"
                                              matTooltip="Wenn Sie Bestellungen freigeben sollten Sie auch mindestens die Berechtigung zum Einsehen von neuen Bestellungen setzen."
                                        >info
                                    </mat-icon>
                                </label>
                            </div>
                            <div class="column is-2">
                                <mat-slide-toggle  formControlName="can_order" color="primary" id="info"></mat-slide-toggle>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-10">
                                <label for="new_can_view">
                                    Neue Bestellungen Einsehen
                                </label>
                            </div>
                            <div class="column is-2">
                                <mat-slide-toggle color="primary" formControlName="can_view" id="new_can_view"></mat-slide-toggle>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-10">
                                <label for="new_can_download">
                                    Neue Bestellungen Downloaden
                                </label>
                            </div>
                            <div class="column is-2">
                                <mat-slide-toggle color="primary" formControlName="can_download" id="new_can_download"></mat-slide-toggle>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card-content>
            <mat-card-actions align="end">
                <a class="button cancel" (click)="cancel()" style="vertical-align: middle; margin-right:1em">Abbrechen</a>
                <a class="button" (click)="createGroup()" style="vertical-align: middle">Anlegen</a>
            </mat-card-actions>
        </mat-card>
    </mat-tab>
</mat-tab-group>
